<sbb-page-layout>
  <h1>{{ "app.view.project.projects-view.projects" | translate }}</h1>

  <div class="actions">
    <input
      [formControl]="searchControl"
      class="search"
      type="text"
      sbbInput
      [placeholder]="'app.view.project.projects-view.search-project' | translate"
    />
    <sbb-toggle-switch-button
      [labelTrue]="'app.view.project.projects-view.show-archive' | translate"
      [checked]="showArchiveControl.getRawValue()"
      (checkedChanged)="showArchiveControl.setValue($event)"
    />
  </div>

  <sbb-card-grid>
    <sbb-card
      *ngIf="!showArchiveControl.value"
      icon="plus-medium"
      (iconClick)="onAddProjectClicked()"
    ></sbb-card>
    <sbb-card
      *ngFor="let project of projectService.filteredProjects | async"
      [title]="
        project.name +
        (project.isArchived ? ' ' + ('app.view.project.projects-view.archived' | translate) : '')
      "
      [route]="['/projects', project.id]"
      [actions]="getProjectDataActions(project)"
    >
    </sbb-card>
  </sbb-card-grid>

  <div style="min-height: 32px"></div>

  <sbb-confirmation-dialog></sbb-confirmation-dialog>
</sbb-page-layout>
